var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPendingIcon = function SvgPendingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.437 2.624c-2.926 0-5.313 2.4-5.313 5.376 0 2.977 2.387 5.376 5.313 5.376a5.278 5.278 0 0 0 4.13-1.994.812.812 0 1 1 1.268 1.015A6.902 6.902 0 0 1 7.437 15C3.598 15 .5 11.858.5 8s3.098-7 6.937-7c3.488 0 6.365 2.593 6.862 5.961a.812.812 0 0 1 .997 1.266l-1.36 1.376a.812.812 0 0 1-1.155 0L11.42 8.228a.812.812 0 0 1 1.154-1.143l.118.12c-.38-2.598-2.594-4.58-5.255-4.58Zm0 1.126c.449 0 .812.364.812.812v3.006L9.933 8.7a.812.812 0 1 1-.908 1.348L6.984 8.674A.812.812 0 0 1 6.625 8V4.562c0-.448.364-.812.812-.812Z",
    fill: "currentColor"
  })));
};

export default SvgPendingIcon;